export default {
      id: "ic_unblock_user-usage",
      viewBox: "0 0 24 25",
      url: "/" + "images/icons.3.109.2.svg#ic_unblock_user-usage",
      toString: function () {
        return this.url;
      }
    }